import type { FieldAnchor } from "web_myplann/Shared/Types/FieldAnchor";

export const holdFieldAtAnchor = ({ field, scroller, top }: FieldAnchor) => {
	const drift = field.getBoundingClientRect().top - top;
	if (drift > 0) {
		scroller.scrollTop += drift;
	}
};
